import { getServerSideData } from "../../../page";

export default class ItemBase {
    constructor(params, optsClass) {
        this.params = params;

        this.optsClass = optsClass;
        this.optDisposers = [];

        this.root = ko.unwrap(params.item);

        if (this.optsClass) {
            this.root.__trackingEnabled && this.root.__trackingEnabled(false);
            this.root.opts(new this.optsClass(ko.unwrap(this.root.opts), this.params));
            this.root.__trackingEnabled && this.root.__trackingEnabled(true);
        }

        this.allTours = ko.observableArray(getServerSideData('tours' || []));
        this.segments = getServerSideData('segments');
    }

    get opts() {
        if (!this.optsClass) return null;

        const o = ko.unwrap(this.root.opts);

        if (!o) {
            this.root.__trackingEnabled && this.root.__trackingEnabled(false);
            this.root.opts(new this.optsClass)
            this.root.__trackingEnabled && this.root.__trackingEnabled(true);
        }

        return o;
    }

    bindOpt(key, fn) {
        ko.unwrap(this.root.opts)[key].subscribe((newVal) => {
            fn(newVal);
            //console.log('AAA', this.params);
            this.params.onUpdated();
        })
    }

    bindLocalizableProp(observable, defaultVal) {
        return ko.computed({
            read: () => {
                var val = observable();
                if (!val) {
                    return defaultVal;
                }

                const res = ko.unwrap(observable()[this.params.selectedLanguage()]);

                if (res === '' || !res) return defaultVal;

                return res;
            },
            write: (val) => {
                var curV = observable();

                if (!curV) {
                    curV = {};
                }

                curV[this.params.selectedLanguage()] = val;

                observable(curV);

                this.params.onUpdated();
            }
        });
    }
}